module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.a116c510.png";